import ERRORS from './error'
import { convertNumber, convertDate, calcDateDifference, getMoment } from './_utils'
import { dateSettings } from './setting'

export const DATE_HELPER = {
  GETYEAR: {
    title: '获取年',
    usage: 'GETYEAR(数字)',
    desc: '获取传入年数的时间戳',
    example: 'GETYEAR(3) => 3 * 365 * 24 * 60 * 60'
  },

  GETQUARTER: {
    title: '获取季度',
    usage: 'GETQUARTER(数字)',
    desc: '获取传入季度数的时间戳',
    example: 'GETQUARTER(2) => 2 * 3 * 30 * 24 * 60 * 60'
  },

  GETMONTH: {
    title: '获取月',
    usage: 'GETMONTH(数字)',
    desc: '获取传入月份数的时间戳',
    example: 'GETMONTH(3) => 3 * 30 * 24 * 60 * 60'
  },

  GETDAY: {
    title: '获取日',
    usage: 'GETDAY(数字)',
    desc: '获取传入天数的时间戳',
    example: 'GETDAY(3) => 3 * 24 * 60 * 60'
  },

  GETWEEK: {
    title: '获取周',
    usage: 'GETWEEK(数字)',
    desc: '获取传入周数的时间戳',
    example: 'GETWEEK(3) => 3 * 7 * 24 * 60 * 60'
  },

  GETHOUR: {
    title: '获取小时',
    usage: 'GETHOUR(数字)',
    desc: '获取传入小时数的时间戳',
    example: 'GETHOUR(3) => 3 * 60 * 60'
  },

  GETMINUTE: {
    title: '获取分钟',
    usage: 'GETMINUTE(数字)',
    desc: '获取传入分钟数的时间戳',
    example: 'GETMINUTE(3) => 3 * 60'
  },

  GETSECOND: {
    title: '获取秒钟',
    usage: 'GETSECOND(数字)',
    desc: '获取传入秒钟数的时间戳',
    example: 'GETSECOND(3) => 3'
  },

  DATENOW: {
    title: '返回当前时间',
    usage: 'DATENOW()',
    desc: '返回当前时间的时间戳',
    example: 'DATENOW() => 1670482443'
  },

  MINUTE: {
    title: '返回分钟数',
    usage: 'MINUTE(日期时间/时间)',
    desc: '返回时间中的分钟数，返回值范围在 0 - 59 之间',
    example: 'MINUTE("2022-5-1 11:59") => 结果: 59'
  },

  HOUR: {
    title: '返回小时数',
    usage: 'HOUR(日期时间/时间)',
    desc: '返回时间中的小时数，返回值范围在 0 - 23 之间',
    example: 'HOUR("2022-5-1 11:59") => 结果: 11'
  },

  DAY: {
    title: '返回天数',
    usage: 'DAY([日期时间/时间])',
    desc: '返回日期的天数，返回值范围在 1 - 31 之间,如果不传入日期时间，则返回当前日期的天数',
    example: 'DAY("2022-5-1 11:59") => 结果: 1'
  },

  WEEKDAY: {
    title: '返回星期数',
    usage: 'WEEKDAY(日期时间/时间)',
    desc: '返回日期的星期数，返回值范围在 1 - 7 之间',
    example: 'WEEKDAY("2022-5-1 11:59") => 结果: 7'
  },

  MONTH: {
    title: '返回月数',
    usage: 'MONTH(日期时间/时间)',
    desc: '返回日期的月数，返回值范围在 1 - 12 之间',
    example: 'MONTH("2022-5-1 11:59") => 结果: 5'
  },

  MONTHDAY: {
    title: '返回月的天数',
    usage: 'MONTHDAY([日期时间/时间])',
    desc: '返回指定月的天数，返回值范围在 1 - 31 之间，如果不传入日期时间，则返回当前月的天数',
    example: 'MONTHDAY("2022-5-1 11:59") => 结果: 31'
  },

  YEAR: {
    title: '返回年数',
    usage: 'YEAR(日期时间/时间)',
    desc: '返回日期的年数',
    example: 'YEAR("2022-5-1 11:59") => 结果: 2022'
  },

  DATEIF: {
    title: '时长',
    usage: 'DATEIF(开始,结束,[输出单位])',
    desc: '计算两个日期/时间之间的时长，并精确到年、月、天、小时或分; 输出单位："y"-年；"M"-月；"d"-天；"h"-小时；"m"-分钟；"s"-秒钟；如果不指定这个参数，则默认为"d"',
    example: 'DATEIF("2022-3-8","2022-3-14","d") => 结果: 6'
  },

  DATEFORMAT: {
    title: '转换日期格式',
    usage: 'DATEFORMAT(日期时间/时间, 转换格式)',
    desc: '将传入日期转化为指定格式输出, 转换格式:YYYY代表年 MM月 DD日 HH小时 mm分钟 ss秒钟',
    example: 'DATEFORMAT("2022-3-8 08:08","YYYY-MM-DD") => 结果: 2022-03-08'
  },

  DATEADD: {
    title: '日期加',
    usage: 'DATEADD(日期时间/时间, 数量, [要加日期中的哪一个元素], [转换格式])',
    desc: '将日期加上某值得到计算后的结果，要加日期中的哪一个元素："y"-年；"Q"-季度；"M"-月；"w"-周；"d"-天；"h"-小时；"m"-分钟；"s"-秒；"ms"-毫秒；如果不指定这个参数，则默认为"d", [转换格式]:YYYY代表年 MM月 DD日 HH小时 mm分钟 ss秒钟 TIMESTAMP时间戳 如果不指定这个参数则返回计算后的YYYY-MM-DD',
    example: 'DATEADD("2022-1-31",1, "M") => 结果: 2022-2-28'
  },

  DATESUBSTRACT: {
    title: '日期减',
    usage: 'DATESUBSTRACT(日期时间/时间, 数量, [要减日期中的哪一个元素], [转换格式])',
    desc: '将日期减去某值得到计算后的结果，要减日期中的哪一个元素："y"-年；"Q"-季度；"M"-月；"w"-周；"d"-天；"h"-小时；"m"-分钟；"s"-秒；"ms"-毫秒；如果不指定这个参数，则默认为"d", [转换格式]:YYYY代表年 MM月 DD日 HH小时 mm分钟 ss秒钟 TIMESTAMP时间戳 如果不指定这个参数则返回计算后的YYYY-MM-DD',
    example: 'DATESUBSTRACT("2022-2-28",1, "M") => 结果: 2022-01-31'
  }
}

export const GETYEAR = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('GETYEAR', 1, args.length)
  return convertNumber(args[0]) * dateSettings['Y']['value']
}

export const GETQUARTER = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('GETQUARTER', 1, args.length)
  return convertNumber(args[0]) * dateSettings['Q']['value']
}

export const GETMONTH = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('GETMONTH', 1, args.length)
  return convertNumber(args[0]) * dateSettings['M']['value']
}

export const GETDAY = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('GETDAY', 1, args.length)
  return convertNumber(args[0]) * dateSettings['D']['value']
}

export const GETWEEK = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('GETWEEK', 1, args.length)
  return convertNumber(args[0]) * dateSettings['W']['value']
}

export const GETHOUR = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('GETHOUR', 1, args.length)
  return convertNumber(args[0]) * dateSettings['H']['value']
}

export const GETMINUTE = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('GETMINUTE', 1, args.length)
  return convertNumber(args[0]) * dateSettings['MIN']['value']
}

export const GETSECOND = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('GETSECOND', 1, args.length)
  return convertNumber(args[0]) * dateSettings['S']['value']
}

export const DATENOW = () => {
  return Math.floor(new Date().getTime() / 1000)
}

export const MINUTE = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('MINUTE', 1, args.length)
  return convertNumber(convertDate(args[0], 'mm'))
}

export const HOUR = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('HOUR', 1, args.length)
  return convertNumber(convertDate(args[0], 'HH'))
}

export const DAY = (v) => {
  return convertNumber(convertDate(v || DATENOW(), 'DD'))
}

export const MONTHDAY = (v) => {
  return convertNumber(convertDate(v || DATENOW(), 'MOMENT').endOf('month').format('DD'))
}

export const WEEKDAY = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('WEEKDAY', 1, args.length)
  return convertNumber(convertDate(args[0], 'WEEK'))
}

export const MONTH = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('MONTH', 1, args.length)
  return convertNumber(convertDate(args[0], 'MM'))
}

export const YEAR = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('YEAR', 1, args.length)
  return convertNumber(convertDate(args[0], 'YYYY'))
}

export const DATEIF = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('DATEIF', 2, args.length, false)
  let [start, end, format = 'd'] = args
  return calcDateDifference(start, end, format)
}

export const DATEFORMAT = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('DATEFORMAT', 2, args.length)
  let [date, format] = args
  return convertDate(date, format)
}

export const DATEADD = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('DATEADD', 2, args.length)
  let [date, number, flag = 'd', format = 'YYYY-MM-DD'] = args
  const momentInstance = convertDate(date, 'MOMENT').add(convertNumber(number), flag)
  if (format === 'TIMESTAMP') return momentInstance.valueOf() / 1000
  return momentInstance.format(format)
}

export const DATESUBSTRACT = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('DATEADD', 2, args.length)
  let [date, number, flag = 'd', format = 'YYYY-MM-DD'] = args
  const momentInstance = convertDate(date, 'MOMENT').subtract(convertNumber(number), flag)
  if (format === 'TIMESTAMP') return momentInstance.valueOf() / 1000
  return momentInstance.format(format)
}

export const MOMENT = () => getMoment()
